import { setMachineDetailsData, resetMachineDetailsData } from '../../../redux/machineDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import MachineDetailsHeader from './machineDetailsHeader';
import { useParams, useLocation } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import MachineDetailsTabs from './machineDetailsTabs';
import { useDispatch } from 'react-redux';
import NoRecord from '../../NoRecord';
import axios from 'axios';

const MachineDetails = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  const [errMsg, setErrMsg] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState(location.state ?? '1');

  const fetchMachineDetails = useCallback(async () => {
    try {
      const response = await axios.get(`machine/${id}`);
      if ((response.status === 200 || response.status === 201) && response.data) {
        dispatch(setMachineDetailsData(response.data));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setErrMsg(error.message);
      console.error('Error Fetching medical files:', error);
      CustomErrorLogger(error, "Fetch Machine Details Error in MachineDetails");
    }
  }, [id, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchMachineDetails()
    return () => {
      dispatch(resetMachineDetailsData());
    };
  }, [fetchMachineDetails, id, dispatch]);

  return (
    <Box>
      {loading ?
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh',
          }}
        >
          <CircularProgress
            sx={{
              '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
            }}
          />
        </Box>
        :
        errMsg ?
          <NoRecord
            description="Machine non trouvée"
          />
          :
          <Box>
            <MachineDetailsHeader selectedTab={selectedTab} />
            <MachineDetailsTabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
            <SuccessfullModifyDialog />
          </Box>
      }
    </Box>
  );
}

export default MachineDetails;